import React, { useEffect } from "react";
import AOS from "aos";
import CountUp from "react-countup"; // Import CountUp library

const CountCard = ({ title, count, Icon }) => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  const formatNumber = (value) => {
    if (value >= 1e6) {
      return `${(value / 1e6).toFixed(1)}M`;
    }
    if (value >= 1e3) {
      return `${(value / 1e3).toFixed(1)}k`;
    }
    return value.toLocaleString();
  };

  return (
    <div
      data-aos="fade-up"
      className="bg-secondary dark:bg-[#333333] shadow-lg rounded-lg p-6 w-80 h-48 flex flex-col items-center justify-center text-center"
    >
      {/* Icon Section */}
      <div className="flex items-center justify-center mb-4">
        <Icon size="2.5rem" color="#114787" />
      </div>

      {/* Title Section */}
      <div className="text-gray-500 dark:text-[#fbfbfb] text-lg">
        {title}
      </div>

      {/* CountUp with formatted number */}
      <div className="text-black dark:text-darkTextColor text-3xl font-bold">
        <CountUp
          start={0}
          end={count}
          duration={2}
          separator=","
          formattingFn={formatNumber}
        />
      </div>
    </div>
  );
};

export default CountCard;
